import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// All countries from database
const COUNTRIES = [
    { id: 1, name: 'Mexico' },
    { id: 2, name: 'United States' },
    { id: 3, name: 'Aruba' },
    { id: 4, name: 'Afghanistan' },
    { id: 5, name: 'Angola' },
    { id: 6, name: 'Anguilla' },
    { id: 7, name: 'Åland Islands' },
    { id: 8, name: 'Albania' },
    { id: 9, name: 'Andorra' },
    { id: 10, name: 'Netherlands Antilles' },
    { id: 11, name: 'United Arab Emirates' },
    { id: 12, name: 'Argentina' },
    { id: 13, name: 'Armenia' },
    { id: 14, name: 'American Samoa' },
    { id: 15, name: 'Antarctica' },
    { id: 16, name: 'French Southern Territories' },
    { id: 17, name: 'Antigua and Barbuda' },
    { id: 18, name: 'Australia' },
    { id: 19, name: 'Austria' },
    { id: 20, name: 'Azerbaijan' },
    { id: 21, name: 'Burundi' },
    { id: 22, name: 'Belgium' },
    { id: 23, name: 'Benin' },
    { id: 24, name: 'Burkina Faso' },
    { id: 25, name: 'Bangladesh' },
    { id: 26, name: 'Bulgaria' },
    { id: 27, name: 'Bahrain' },
    { id: 28, name: 'Bahamas' },
    { id: 29, name: 'Bosnia and Herzegovina' },
    { id: 30, name: 'Saint Barthélemy' },
    { id: 31, name: 'Belarus' },
    { id: 32, name: 'Belize' },
    { id: 33, name: 'Bermuda' },
    { id: 34, name: 'Bolivia, Plurinational State of' },
    { id: 35, name: 'Brazil' },
    { id: 36, name: 'Barbados' },
    { id: 37, name: 'Brunei Darussalam' },
    { id: 38, name: 'Bhutan' },
    { id: 39, name: 'Bouvet Island' },
    { id: 40, name: 'Botswana' },
    { id: 41, name: 'Central African Republic' },
    { id: 42, name: 'Canada' },
    { id: 43, name: 'Cocos (Keeling) Islands' },
    { id: 44, name: 'Switzerland' },
    { id: 45, name: 'Chile' },
    { id: 46, name: 'China' },
    { id: 47, name: 'Cote dIvoire' },
    { id: 48, name: 'Cameroon' },
    { id: 49, name: 'Congo, Democratic Republic' },
    { id: 50, name: 'Congo' },
    { id: 51, name: 'Cook Islands' },
    { id: 52, name: 'Colombia' },
    { id: 53, name: 'Comoros' },
    { id: 54, name: 'Cape Verde' },
    { id: 55, name: 'Costa Rica' },
    { id: 56, name: 'Cuba' },
    { id: 57, name: 'Christmas Island' },
    { id: 58, name: 'Cayman Islands' },
    { id: 59, name: 'Cyprus' },
    { id: 60, name: 'Czech Republic' },
    { id: 61, name: 'Germany' },
    { id: 62, name: 'Djibouti' },
    { id: 63, name: 'Dominica' },
    { id: 64, name: 'Denmark' },
    { id: 65, name: 'Dominican Republic' },
    { id: 66, name: 'Algeria' },
    { id: 67, name: 'Ecuador' },
    { id: 68, name: 'Egypt' },
    { id: 69, name: 'Eritrea' },
    { id: 70, name: 'Western Sahara' },
    { id: 71, name: 'Spain' },
    { id: 72, name: 'Estonia' },
    { id: 73, name: 'Ethiopia' },
    { id: 74, name: 'Finland' },
    { id: 75, name: 'Fiji' },
    { id: 76, name: 'Falkland Islands (Malvinas)' },
    { id: 77, name: 'France' },
    { id: 78, name: 'Faroe Islands' },
    { id: 79, name: 'Micronesia, Federated States of' },
    { id: 80, name: 'Gabon' },
    { id: 81, name: 'United Kingdom' },
    { id: 82, name: 'Georgia' },
    { id: 83, name: 'Guernsey' },
    { id: 84, name: 'Ghana' },
    { id: 85, name: 'Gibraltar' },
    { id: 86, name: 'Guinea' },
    { id: 87, name: 'Guadeloupe' },
    { id: 88, name: 'Gambia' },
    { id: 89, name: 'Guinea-Bissau' },
    { id: 90, name: 'Equatorial Guinea' },
    { id: 91, name: 'Greece' },
    { id: 92, name: 'Grenada' },
    { id: 93, name: 'Greenland' },
    { id: 94, name: 'Guatemala' },
    { id: 95, name: 'French Guiana' },
    { id: 96, name: 'Guam' },
    { id: 97, name: 'Guyana' },
    { id: 98, name: 'Hong Kong' },
    { id: 99, name: 'Heard Island and McDonald Islands' },
    { id: 100, name: 'Honduras' },
    { id: 101, name: 'Croatia' },
    { id: 102, name: 'Haiti' },
    { id: 103, name: 'Hungary' },
    { id: 104, name: 'Indonesia' },
    { id: 105, name: 'Isle of Man' },
    { id: 106, name: 'India' },
    { id: 107, name: 'British Indian Ocean Territory' },
    { id: 108, name: 'Ireland' },
    { id: 109, name: 'Iran, Islamic Republic of' },
    { id: 110, name: 'Iraq' },
    { id: 111, name: 'Iceland' },
    { id: 112, name: 'Israel' },
    { id: 113, name: 'Italy' },
    { id: 114, name: 'Jamaica' },
    { id: 115, name: 'Jersey' },
    { id: 116, name: 'Jordan' },
    { id: 117, name: 'Japan' },
    { id: 118, name: 'Kazakhstan' },
    { id: 119, name: 'Kenya' },
    { id: 120, name: 'Kyrgyzstan' },
    { id: 121, name: 'Cambodia' },
    { id: 122, name: 'Kiribati' },
    { id: 123, name: 'Saint Kitts and Nevis' },
    { id: 124, name: 'Korea, Republic of' },
    { id: 125, name: 'Kuwait' },
    { id: 126, name: 'Lao People Democratic Republic' },
    { id: 127, name: 'Lebanon' },
    { id: 128, name: 'Liberia' },
    { id: 129, name: 'Libyan Arab Jamahiriya' },
    { id: 130, name: 'Saint Lucia' },
    { id: 131, name: 'Liechtenstein' },
    { id: 132, name: 'Sri Lanka' },
    { id: 133, name: 'Lesotho' },
    { id: 134, name: 'Lithuania' },
    { id: 135, name: 'Luxembourg' },
    { id: 136, name: 'Latvia' },
    { id: 137, name: 'Macao' },
    { id: 138, name: 'Saint Martin (French part)' },
    { id: 139, name: 'Morocco' },
    { id: 140, name: 'Monaco' },
    { id: 141, name: 'Moldova, Republic of' },
    { id: 142, name: 'Madagascar' },
    { id: 143, name: 'Maldives' },
    { id: 144, name: 'Marshall Islands' },
    { id: 145, name: 'Macedonia' },
    { id: 146, name: 'Mali' },
    { id: 147, name: 'Malta' },
    { id: 148, name: 'Myanmar' },
    { id: 149, name: 'Montenegro' },
    { id: 150, name: 'Mongolia' },
    { id: 151, name: 'Northern Mariana Islands' },
    { id: 152, name: 'Mozambique' },
    { id: 153, name: 'Mauritania' },
    { id: 154, name: 'Montserrat' },
    { id: 155, name: 'Martinique' },
    { id: 156, name: 'Mauritius' },
    { id: 157, name: 'Malawi' },
    { id: 158, name: 'Malaysia' },
    { id: 159, name: 'Mayotte' },
    { id: 160, name: 'Namibia' },
    { id: 161, name: 'New Caledonia' },
    { id: 162, name: 'Niger' },
    { id: 163, name: 'Norfolk Island' },
    { id: 164, name: 'Nigeria' },
    { id: 165, name: 'Nicaragua' },
    { id: 166, name: 'Niue' },
    { id: 167, name: 'Netherlands' },
    { id: 168, name: 'Norway' },
    { id: 169, name: 'Nepal' },
    { id: 170, name: 'Nauru' },
    { id: 171, name: 'New Zealand' },
    { id: 172, name: 'Oman' },
    { id: 173, name: 'Pakistan' },
    { id: 174, name: 'Panama' },
    { id: 175, name: 'Pitcairn' },
    { id: 176, name: 'Peru' },
    { id: 177, name: 'Philippines' },
    { id: 178, name: 'Palau' },
    { id: 179, name: 'Papua New Guinea' },
    { id: 180, name: 'Poland' },
    { id: 181, name: 'Puerto Rico' },
    { id: 182, name: 'Korea, Democratic Republic' },
    { id: 183, name: 'Portugal' },
    { id: 184, name: 'Paraguay' },
    { id: 185, name: 'Palestinian Territory, Occupied' },
    { id: 186, name: 'French Polynesia' },
    { id: 187, name: 'Qatar' },
    { id: 188, name: 'Réunion' },
    { id: 189, name: 'Romania' },
    { id: 190, name: 'Russian Federation' },
    { id: 191, name: 'Rwanda' },
    { id: 192, name: 'Saudi Arabia' },
    { id: 193, name: 'Sudan' },
    { id: 194, name: 'Senegal' },
    { id: 195, name: 'Singapore' },
    { id: 196, name: 'South Georgia and Sandwich Isl' },
    { id: 197, name: 'Saint Helena, Ascension and Tristan' },
    { id: 198, name: 'Svalbard and Jan Mayen' },
    { id: 199, name: 'Solomon Islands' },
    { id: 200, name: 'Sierra Leone' },
    { id: 201, name: 'El Salvador' },
    { id: 202, name: 'San Marino' },
    { id: 203, name: 'Somalia' },
    { id: 204, name: 'Saint Pierre and Miquelon' },
    { id: 205, name: 'Serbia' },
    { id: 206, name: 'Sao Tome and Principe' },
    { id: 207, name: 'Suriname' },
    { id: 208, name: 'Slovakia' },
    { id: 209, name: 'Slovenia' },
    { id: 210, name: 'Sweden' },
    { id: 211, name: 'Swaziland' },
    { id: 212, name: 'Seychelles' },
    { id: 213, name: 'Syrian Arab Republic' },
    { id: 214, name: 'Turks and Caicos Islands' },
    { id: 215, name: 'Chad' },
    { id: 216, name: 'Togo' },
    { id: 217, name: 'Thailand' },
    { id: 218, name: 'Tajikistan' },
    { id: 219, name: 'Tokelau' },
    { id: 220, name: 'Turkmenistan' },
    { id: 221, name: 'Timor-Leste' },
    { id: 222, name: 'Tonga' },
    { id: 223, name: 'Trinidad and Tobago' },
    { id: 224, name: 'Tunisia' },
    { id: 225, name: 'Turkey' },
    { id: 226, name: 'Tuvalu' },
    { id: 227, name: 'Taiwan, Province of China' },
    { id: 228, name: 'Tanzania, United Republic of' },
    { id: 229, name: 'Uganda' },
    { id: 230, name: 'Ukraine' },
    { id: 231, name: 'United States Minor Outlying Isl' },
    { id: 232, name: 'Uruguay' },
    { id: 233, name: 'Uzbekistan' },
    { id: 234, name: 'Holy See (Vatican City State)' },
    { id: 235, name: 'Saint Vincent and the Grenadines' },
    { id: 236, name: 'Venezuela, Bolivarian Republic of' },
    { id: 237, name: 'Virgin Islands, British' },
    { id: 238, name: 'Virgin Islands, U.S.' },
    { id: 239, name: 'Viet Nam' },
    { id: 240, name: 'Vanuatu' },
    { id: 241, name: 'Wallis and Futuna' },
    { id: 242, name: 'Samoa' },
    { id: 243, name: 'Yemen' },
    { id: 244, name: 'South Africa' },
    { id: 245, name: 'Zambia' },
    { id: 246, name: 'Zimbabwe' },
];

// Mexican states (IDs 1-32)
const MEXICAN_STATES = [
    { id: 1, name: 'Aguascalientes' },
    { id: 2, name: 'Baja California' },
    { id: 3, name: 'Baja California Sur' },
    { id: 4, name: 'Campeche' },
    { id: 5, name: 'Chiapas' },
    { id: 6, name: 'Chihuahua' },
    { id: 7, name: 'Coahuila' },
    { id: 8, name: 'Colima' },
    { id: 9, name: 'Ciudad de México' },
    { id: 10, name: 'Durango' },
    { id: 11, name: 'Guanajuato' },
    { id: 12, name: 'Guerrero' },
    { id: 13, name: 'Hidalgo' },
    { id: 14, name: 'Jalisco' },
    { id: 15, name: 'Estado de México' },
    { id: 16, name: 'Michoacán' },
    { id: 17, name: 'Morelos' },
    { id: 18, name: 'Nayarit' },
    { id: 19, name: 'Nuevo León' },
    { id: 20, name: 'Oaxaca' },
    { id: 21, name: 'Puebla' },
    { id: 22, name: 'Querétaro' },
    { id: 23, name: 'Quintana Roo' },
    { id: 24, name: 'San Luis Potosí' },
    { id: 25, name: 'Sinaloa' },
    { id: 26, name: 'Sonora' },
    { id: 27, name: 'Tabasco' },
    { id: 28, name: 'Tamaulipas' },
    { id: 29, name: 'Tlaxcala' },
    { id: 30, name: 'Veracruz' },
    { id: 31, name: 'Yucatán' },
    { id: 32, name: 'Zacatecas' },
];

// US states (IDs 33-82)
const US_STATES = [
    { id: 33, name: 'Alaska', code: 'AK' },
    { id: 34, name: 'Alabama', code: 'AL' },
    { id: 35, name: 'Arkansas', code: 'AR' },
    { id: 36, name: 'Arizona', code: 'AZ' },
    { id: 37, name: 'California', code: 'CA' },
    { id: 38, name: 'Colorado', code: 'CO' },
    { id: 39, name: 'Connecticut', code: 'CT' },
    { id: 40, name: 'Delaware', code: 'DE' },
    { id: 41, name: 'Florida', code: 'FL' },
    { id: 42, name: 'Georgia', code: 'GA' },
    { id: 43, name: 'Hawaii', code: 'HI' },
    { id: 44, name: 'Iowa', code: 'IA' },
    { id: 45, name: 'Idaho', code: 'ID' },
    { id: 46, name: 'Illinois', code: 'IL' },
    { id: 47, name: 'Indiana', code: 'IN' },
    { id: 48, name: 'Kansas', code: 'KS' },
    { id: 49, name: 'Kentucky', code: 'KY' },
    { id: 50, name: 'Louisiana', code: 'LA' },
    { id: 51, name: 'Massachusetts', code: 'MA' },
    { id: 52, name: 'Maryland', code: 'MD' },
    { id: 53, name: 'Maine', code: 'ME' },
    { id: 54, name: 'Michigan', code: 'MI' },
    { id: 55, name: 'Minnesota', code: 'MN' },
    { id: 56, name: 'Missouri', code: 'MO' },
    { id: 57, name: 'Mississippi', code: 'MS' },
    { id: 58, name: 'Montana', code: 'MT' },
    { id: 59, name: 'North Carolina', code: 'NC' },
    { id: 60, name: 'North Dakota', code: 'ND' },
    { id: 61, name: 'Nebraska', code: 'NE' },
    { id: 62, name: 'New Hampshire', code: 'NH' },
    { id: 63, name: 'New Jersey', code: 'NJ' },
    { id: 64, name: 'New Mexico', code: 'NM' },
    { id: 65, name: 'Nevada', code: 'NV' },
    { id: 66, name: 'New York', code: 'NY' },
    { id: 67, name: 'Ohio', code: 'OH' },
    { id: 68, name: 'Oklahoma', code: 'OK' },
    { id: 69, name: 'Oregon', code: 'OR' },
    { id: 70, name: 'Pennsylvania', code: 'PA' },
    { id: 71, name: 'Rhode Island', code: 'RI' },
    { id: 72, name: 'South Carolina', code: 'SC' },
    { id: 73, name: 'South Dakota', code: 'SD' },
    { id: 74, name: 'Tennessee', code: 'TN' },
    { id: 75, name: 'Texas', code: 'TX' },
    { id: 76, name: 'Utah', code: 'UT' },
    { id: 77, name: 'Virginia', code: 'VA' },
    { id: 78, name: 'Vermont', code: 'VT' },
    { id: 79, name: 'Washington', code: 'WA' },
    { id: 80, name: 'Wisconsin', code: 'WI' },
    { id: 81, name: 'West Virginia', code: 'WV' },
    { id: 82, name: 'Wyoming', code: 'WY' },
];

// For countries other than Mexico/USA, the stateId = 83 + (countryId - 3)
const getNAStateId = (countryId: number) => {
    if (countryId <= 2) return null;
    return 83 + (countryId - 3);
};

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Forgot password state
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [forgotPasswordSent, setForgotPasswordSent] = useState(false);
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
    const [forgotPasswordError, setForgotPasswordError] = useState('');

    // Registration modal state
    const [showModal, setShowModal] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [spResult, setSpResult] = useState<any>(null);
    const [captchaQuestion, setCaptchaQuestion] = useState('');
    const [captchaExpected, setCaptchaExpected] = useState<number | null>(null);
    const [captchaInput, setCaptchaInput] = useState('');
    const [registeredEmail, setRegisteredEmail] = useState('');
    
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        street: '',
        apt: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        dob: '',
        phone: '',
        email: '',
        ssn: '',
        usbc: '',
        bowlerType: 0,
        bowlerHand: 'R',
        bowlerGender: 'M',
        password: '',
        confirmPassword: '',
    });

    useEffect(() => {
        if (showModal) {
            const a = Math.floor(Math.random() * 10) + 1;
            const b = Math.floor(Math.random() * 10) + 1;
            setCaptchaQuestion(`What is ${a} + ${b}?`);
            setCaptchaExpected(a + b);
            setCaptchaInput('');
        }
    }, [showModal]);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Trim and validate input
            const trimmedEmail = email.trim();
            const trimmedPassword = password.trim();

            if (!trimmedEmail || !trimmedPassword) {
                setError('Please enter both email and password.');
                setLoading(false);
                return;
            }

            // Call the new auth/login endpoint
            const res = await fetch(`${BACKEND_URL}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: trimmedEmail,
                    password: trimmedPassword
                })
            });

            const data = await res.json();

            if (res.ok && data.success) {
                // Store user data and navigate to dashboard
                localStorage.setItem('loggedInPlayer', JSON.stringify(data.user));
                navigate('/dashboard');
            } else {
                setError(data.error || 'Invalid email or password.');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError('An error occurred while connecting to the server. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setForgotPasswordError('');
        setForgotPasswordLoading(true);

        try {
            const trimmedEmail = forgotPasswordEmail.trim();
            if (!trimmedEmail) {
                setForgotPasswordError('Please enter your email address.');
                setForgotPasswordLoading(false);
                return;
            }

            const res = await fetch(`${BACKEND_URL}/api/auth/request-password-reset`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: trimmedEmail })
            });

            const data = await res.json();

            if (res.ok && data.success) {
                setForgotPasswordSent(true);
            } else {
                setForgotPasswordError(data.error || 'Failed to send reset email.');
            }
        } catch (err) {
            console.error('Forgot password error:', err);
            setForgotPasswordError('An error occurred. Please try again.');
        } finally {
            setForgotPasswordLoading(false);
        }
    };

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleRegisterSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Send form data to backend - convert string IDs to integers (ignore password for now)
        const formDataToSend = {
            firstName: form.firstName,
            lastName: form.lastName,
            street: form.street,
            apt: form.apt,
            city: form.city,
            country: Number(form.country),
            state: Number(form.state),
            zip: form.zip,
            dob: form.dob,
            phone: form.phone,
            email: form.email,
            ssn: form.ssn,
            usbc: form.usbc,
            bowlerType: Number(form.bowlerType),
            bowlerHand: form.bowlerHand,
            bowlerGender: form.bowlerGender,
            // password is not sent - no DB column yet
        };

        const res = await fetch(`${BACKEND_URL}/api/email-registration`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formDataToSend),
        });

        if (res.ok) {
            const data = await res.json();
            setSpResult(data.result);
            setRegisteredEmail(form.email);
            setSubmitted(true);
        } else {
            alert('There was an error sending your registration.');
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSubmitted(false);
        setSpResult(null);
        setRegisteredEmail('');
        setForm({
            firstName: '',
            lastName: '',
            street: '',
            apt: '',
            city: '',
            state: '',
            country: '',
            zip: '',
            dob: '',
            phone: '',
            email: '',
            ssn: '',
            usbc: '',
            bowlerType: 0,
            bowlerHand: 'R',
            bowlerGender: 'M',
            password: '',
            confirmPassword: '',
        });
    };

    const isValidSSN = /^\d{9}$/.test(form.ssn.replace(/\D/g, ''));
    const passwordsMatch = form.password === form.confirmPassword;

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-5">
                    <img 
                        src="/logo.avif" 
                        alt="Register 2 Bowl" 
                        className="h-20 mx-auto mb-3 object-contain"
                    />
                    <h1 className="text-3xl font-bold text-gray-800 mb-1">Welcome Back</h1>
                    
                </div>

                {/* How to access tutorial */}
                <a
                    href="https://www.youtube.com/watch?v=QZ97tzpjUTM"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mb-5 flex items-center gap-3 bg-white rounded-xl shadow border border-gray-100 px-4 py-3 hover:shadow-md hover:border-red-200 transition group"
                >
                    <div className="relative flex-shrink-0 w-24 h-14 rounded-lg overflow-hidden bg-gray-100">
                        <img
                            src={`https://img.youtube.com/vi/QZ97tzpjUTM/mqdefault.jpg`}
                            alt="Tutorial thumbnail"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/10 transition">
                            <svg className="w-7 h-7 text-white drop-shadow" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                            </svg>
                        </div>
                    </div>
                    <div className="min-w-0">
                        <p className="text-xs font-bold text-red-500 uppercase tracking-wider mb-0.5">Access Your Account Tutorial</p>
                        <p className="text-sm font-semibold text-gray-800 leading-tight">How to login and access the portal</p>
                        <p className="text-xs text-gray-400 mt-0.5">Sign in to your TAT account! →</p>
                    </div>
                </a>

                {/* Login Card */}
                <div className="bg-white rounded-2xl shadow-xl p-8">
                    <form onSubmit={handleLogin} className="space-y-6">
                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                                {error}
                            </div>
                        )}

                        <div>
                            <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                Email Address
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                placeholder="Enter your email"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                placeholder="Enter your password"
                            />
                        </div>

                        <div className="flex items-center justify-between">
                            <button
                                type="button"
                                onClick={() => {
                                    setForgotPasswordEmail(email);
                                    setShowForgotPassword(true);
                                    setForgotPasswordSent(false);
                                    setForgotPasswordError('');
                                }}
                                className="text-sm text-blue-600 hover:text-blue-800 font-medium transition"
                            >
                                Forgot your password?
                            </button>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-gray-600">
                            Don't have an account?{' '}
                            <button
                                onClick={() => setShowModal(true)}
                                className="text-blue-600 hover:text-blue-800 font-medium transition"
                            >
                                Register as a new bowler
                            </button>
                        </p>
                    </div>
                </div>

                {/* YouTube Tutorial Banner */}
                <a
                    href="https://www.youtube.com/@RageTechLLC/playlists"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 block w-full rounded-2xl overflow-hidden shadow-xl relative group cursor-pointer"
                    style={{ height: '120px' }}
                >
                    {/* Background screenshot */}
                    <img
                        src="/youtubescreenshot.png"
                        alt="Tutorials"
                        className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-500 opacity-30 group-hover:opacity-50"
                    />
                    {/* Dark glass overlay */}
                    <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px] group-hover:bg-black/40 transition-colors duration-300" />
                    {/* Content */}
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
                        {/* YouTube icon */}
                        <svg className="w-10 h-10 text-red-500 drop-shadow-lg group-hover:scale-110 transition-transform duration-300" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                        </svg>
                        <span className="text-black font-bold text-md tracking-wide drop-shadow-lg">👆 View the Tutorials (English & Spanish) 👆</span>
                    </div>
                </a>

                {/* Footer */}
                <div className="text-center mt-6 text-sm text-gray-500">
                    <p>© 2026 True Amateur Tournaments. All rights reserved.</p>
                </div>
            </div>

            {/* Registration Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 overflow-y-auto">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] my-auto flex flex-col">
                        {!submitted ? (
                            <>
                                {/* Fixed Header */}
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-3 sm:py-4 flex-shrink-0 sticky top-0 z-10">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <h2 className="text-lg sm:text-xl font-bold text-white">Create TAT Account</h2>
                                            <p className="text-blue-100 text-xs mt-0.5">Join the TAT community</p>
                                        </div>
                                        <button
                                            onClick={handleCloseModal}
                                            className="text-white hover:bg-white/20 rounded-lg p-2 transition"
                                        >
                                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {/* Scrollable Content */}
                                <div className="px-4 sm:px-6 py-3 sm:py-4 overflow-y-auto flex-1">

                                    <form onSubmit={handleRegisterSubmit} className="space-y-3">
                                        {/* Personal Information Section */}
                                        <div className="space-y-2">
                                            <h3 className="text-base font-semibold text-gray-800 border-b pb-1.5 mb-2">Personal Information</h3>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-0.5">First Name *</label>
                                                    <input 
                                                        name="firstName" 
                                                        value={form.firstName} 
                                                        onChange={handleFormChange} 
                                                        required 
                                                        className="w-full border border-gray-300 px-3 py-1.5 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="John" 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-0.5">Last Name *</label>
                                                    <input 
                                                        name="lastName" 
                                                        value={form.lastName} 
                                                        onChange={handleFormChange} 
                                                        required 
                                                        className="w-full border border-gray-300 px-3 py-1.5 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="Doe" 
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth *</label>
                                                    <input 
                                                        name="dob" 
                                                        value={form.dob} 
                                                        onChange={handleFormChange} 
                                                        required 
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        type="date" 
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                                                    <input 
                                                        name="phone" 
                                                        value={form.phone} 
                                                        onChange={handleFormChange} 
                                                        required 
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="(555) 123-4567" 
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                                                <input 
                                                    name="email" 
                                                    value={form.email} 
                                                    onChange={handleFormChange} 
                                                    required 
                                                    className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                    placeholder="bowler@example.com" 
                                                    type="email" 
                                                />
                                            </div>
                                        </div>

                                        {/* Address Section */}
                                        <div className="space-y-4">
                                            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Address</h3>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Street Address *</label>
                                                <input
                                                    name="street"
                                                    value={form.street}
                                                    onChange={handleFormChange}
                                                    required
                                                    className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                    placeholder="123 Main St"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Apt, Suite, Unit (Optional)</label>
                                                <input
                                                    name="apt"
                                                    value={form.apt}
                                                    onChange={handleFormChange}
                                                    className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                    placeholder="Apt 4B"
                                                />
                                            </div>
                                            
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">City *</label>
                                                    <input
                                                        name="city"
                                                        value={form.city}
                                                        onChange={handleFormChange}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="Los Angeles"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Zip Code *</label>
                                                    <input
                                                        name="zip"
                                                        value={form.zip}
                                                        onChange={handleFormChange}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="90001"
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Country *</label>
                                                    <select
                                                        name="country"
                                                        value={form.country}
                                                        onChange={(e) => {
                                                            handleFormChange(e);
                                                            setForm(prev => ({ ...prev, state: '' }));
                                                        }}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white transition"
                                                    >
                                                        <option value="">Select Country</option>
                                                        {COUNTRIES.map(country => (
                                                            <option key={country.id} value={country.id.toString()}>
                                                                {country.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">State / Province *</label>
                                                    <select
                                                        name="state"
                                                        value={form.state}
                                                        onChange={handleFormChange}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white transition disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                        disabled={!form.country}
                                                    >
                                                        <option value="">Select State</option>
                                                        {form.country === '1' && MEXICAN_STATES.map(state => (
                                                            <option key={state.id} value={state.id.toString()}>
                                                                {state.name}
                                                            </option>
                                                        ))}
                                                        {form.country === '2' && US_STATES.map(state => (
                                                            <option key={state.id} value={state.id.toString()}>
                                                                {state.code}
                                                            </option>
                                                        ))}
                                                        {form.country && form.country !== '1' && form.country !== '2' && (
                                                            <option value={(getNAStateId(Number(form.country)) || '').toString()}>
                                                                N/A
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Account Security Section */}
                                        <div className="space-y-4">
                                            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Account Security</h3>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
                                                    <input
                                                        name="password"
                                                        type="password"
                                                        value={form.password}
                                                        onChange={handleFormChange}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="••••••••"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password *</label>
                                                    <input
                                                        name="confirmPassword"
                                                        type="password"
                                                        value={form.confirmPassword}
                                                        onChange={handleFormChange}
                                                        required
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="••••••••"
                                                    />
                                                </div>
                                            </div>
                                            {form.password && form.confirmPassword && !passwordsMatch && (
                                                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg text-sm flex items-center gap-2">
                                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                    </svg>
                                                    Passwords do not match
                                                </div>
                                            )}
                                        </div>

                                        {/* Bowling Information Section */}
                                        <div className="space-y-4">
                                            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Bowling Information</h3>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">SSN *</label>
                                                    <input 
                                                        name="ssn" 
                                                        value={form.ssn} 
                                                        onChange={handleFormChange} 
                                                        required 
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="123456789" 
                                                    />
                                                    {form.ssn && !isValidSSN && (
                                                        <p className="text-red-600 text-xs mt-1">SSN must be exactly 9 digits</p>
                                                    )}
                                                    <p className="text-gray-500 text-xs mt-1">International bowlers: enter 111111111</p>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">USBC Number</label>
                                                    <input 
                                                        name="usbc" 
                                                        value={form.usbc} 
                                                        onChange={handleFormChange} 
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                        placeholder="Optional" 
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Bowler Type *</label>
                                                    <select
                                                        name="bowlerType"
                                                        value={form.bowlerType}
                                                        required
                                                        onChange={handleFormChange}
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white transition"
                                                    >
                                                        <option value={0}>Select Type</option>
                                                        <option value={1}>Traditional</option>
                                                        <option value={2}>Two Handed</option>
                                                        <option value={3}>Chopper</option>
                                                        <option value={4}>Backer</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Hand *</label>
                                                    <select
                                                        name="bowlerHand"
                                                        value={form.bowlerHand}
                                                        required
                                                        onChange={handleFormChange}
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white transition"
                                                    >
                                                        <option value={''}>Select Hand</option>
                                                        <option value={'L'}>Left</option>
                                                        <option value={'R'}>Right</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Gender *</label>
                                                    <select
                                                        name="bowlerGender"
                                                        value={form.bowlerGender}
                                                        required
                                                        onChange={handleFormChange}
                                                        className="w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white transition"
                                                    >
                                                        <option value={''}>Select Gender</option>
                                                        <option value={'M'}>Male</option>
                                                        <option value={'F'}>Female</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Security Verification */}
                                    <div className="space-y-2">
                                        <h3 className="text-base font-semibold text-gray-800 border-b pb-1.5 mb-2">Security Verification</h3>
                                        <div>
                                            <label className="block text-xs font-medium text-gray-700 mb-0.5">{captchaQuestion} *</label>
                                            <input
                                                name="captcha"
                                                value={captchaInput}
                                                onChange={e => setCaptchaInput(e.target.value)}
                                                required
                                                className="w-full border border-gray-300 px-3 py-1.5 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                                />
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 sm:pt-6 border-t mt-4">
                                            <button
                                                type="button"
                                                className="px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition text-sm sm:text-base"
                                                onClick={handleCloseModal}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-lg text-sm sm:text-base"
                                                disabled={
                                                    Number(captchaInput) !== captchaExpected ||
                                                    !isValidSSN ||
                                                    !passwordsMatch ||
                                                    form.bowlerType === 0 ||
                                                    form.bowlerHand === '' ||
                                                    form.bowlerGender === ''
                                                }
                                            >
                                                Create Account
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </>
                        ) : (
                            <div className="text-center p-4 sm:p-8 flex-1 overflow-y-auto">
                                {/* CHECK IF IT'S AN ERROR CODE (1-2) OR SUCCESS (0 or TAT ID) */}
                                {spResult >= 1 && spResult <= 2 ? (
                                    // ERROR CASE - Error codes 1 and 2
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-red-700">Registration Error</h2>
                                        <p className="m-4">
                                            {spResult === 1 && "A player with this name and date of birth already exists. Please use the login form or contact support if you forgot your credentials."}<br />
                                            {spResult === 2 && "Date of birth is required for registration."}
                                        </p>
                                    </>
                                ) : spResult === 0 ? (
                                    // ERROR CASE - Should never happen (0 means success but no TAT ID?)
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-red-700">Registration Error</h2>
                                        <p className="mb-4">
                                            Registration completed but no TAT ID was returned.<br />
                                            Please contact support at <b>bowlingtat@gmail.com</b>.
                                        </p>
                                    </>
                                ) : (
                                    // SUCCESS CASE - Any other number is the TAT ID
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-green-700">🎳 Registration Successful!</h2>
                                        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4 text-left">
                                            <p className="mb-2"><strong>Your TAT ID:</strong> {spResult}</p>
                                            <p className="mb-2"><strong>Email:</strong> {registeredEmail}</p>
                                        </div>
                                        <p className="text-gray-700 mb-4">
                                            Please use your email and password to log in and start registering for tournaments!
                                        </p>
                                    </>
                                )}

                                <button
                                    className="px-6 py-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-semibold shadow-lg transition"
                                    onClick={handleCloseModal}
                                >
                                    {spResult >= 1 && spResult <= 2 ? 'Try Again' : 'Go to Login'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Forgot Password Modal */}
            {showForgotPassword && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
                        {!forgotPasswordSent ? (
                            <>
                                <div className="text-center mb-6">
                                    <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <h2 className="text-2xl font-bold text-gray-900">Reset Your Password</h2>
                                    <p className="text-gray-600 mt-2">Enter your email address and we'll send you a link to reset your password.</p>
                                </div>

                                <form onSubmit={handleForgotPassword} className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
                                        <input
                                            type="email"
                                            value={forgotPasswordEmail}
                                            onChange={(e) => setForgotPasswordEmail(e.target.value)}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                                            placeholder="Enter your email"
                                        />
                                    </div>

                                    {forgotPasswordError && (
                                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                                            {forgotPasswordError}
                                        </div>
                                    )}

                                    <div className="flex gap-3">
                                        <button
                                            type="button"
                                            onClick={() => setShowForgotPassword(false)}
                                            className="flex-1 px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={forgotPasswordLoading}
                                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {forgotPasswordLoading ? 'Sending...' : 'Send Reset Link'}
                                        </button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <div className="text-center">
                                    <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                        <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Check Your Email</h2>
                                    <p className="text-gray-600 mb-6">
                                        If an account exists with that email, we've sent password reset instructions.
                                    </p>
                                    <button
                                        onClick={() => setShowForgotPassword(false)}
                                        className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition"
                                    >
                                        Done
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
